import React, { useRef, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { categories } from "../../helpers/mock-data";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { createNewQuestion } from "../../services/documents/documents.context";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";


export const QuestionAddPage = () => {

    const { token } = useAuth();

    const fileButton = useRef();

    const [onErr, setOnErr] = useState(false);

    const [inputData, setInputData] = useState({
        document: '',
        title: '',
        field: '',
        examYear: ''
    });

    const years = [];
    for (let n = 1990; n < 2035; n++) {
        years.push(n);
    }

    const [prevName, setPrevName] = useState(null);

    const [loading, setLoading] = useState(false);
    const [valError, setValError] = useState({
        caption: null,
        message: null
    });

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        const { title, document, field, examYear } = inputData;
        return isNull(title) || isNull(document) || isNull(field) || isNull(examYear);
    }


    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Add a Past Question"} background={"/media/tutorial-bg.jpg"} />
            {(loading) && <Loader />}
            {onErr &&
                <AppAlert
                    caption={valError.caption}
                    message={valError.message}
                    close={() => setOnErr(false)}
                    accept={"Ok"}
                    acceptAction={valError.action}
                />
            }
            <div className="form-container">
                <div className="input-container">
                    <span className="input-cap">
                        Title
                        <span className="req-asterix">*</span>
                    </span>

                    <input
                        type="text"
                        placeholder="Enter tutorial title"
                        className="input"
                        onChange={(e) => setInputData((data) =>
                            ({ ...data, title: e.target.value })
                        )}
                        value={inputData.title}
                    />
                </div>
                <div className="input-container">
                    <span className="input-cap">
                        Field of study
                        <span className="req-asterix">*</span>
                    </span>
                    <select
                        type="text"
                        name="category"
                        id="category"
                        className={classNames("input", "category")}
                        required
                        onChange={(e) => setInputData((data) => (
                            { ...data, field: e.target.value }
                        ))}
                    >
                        <option defaultValue={''} selected disabled>
                            ---Choose subject area---
                        </option>
                        {categories.map((category, i) => (
                            <option value={category} key={i} >{category}</option>
                        ))}
                    </select>
                </div>
                <div className="input-container">
                    <span className="input-cap">
                        Examination year
                        <span className="req-asterix">*</span>
                    </span>
                    <select
                        type="text"
                        name="examYear"
                        id="examYear"
                        className={classNames("input", "category")}
                        required
                        onChange={(e) => setInputData((data) => (
                            { ...data, examYear: e.target.value }
                        ))}
                    >
                        <option defaultValue={''} selected disabled>
                            ---Choose exam year---
                        </option>
                        {years.map((yr, i) => (
                            <option value={yr} key={i} >{yr}</option>
                        ))}
                    </select>
                </div>
                <div className="file-btn-container">
                    <input
                        type="file"
                        className="file-button"
                        ref={fileButton}
                        onChange={(e) => {
                            e.preventDefault();
                            let fileType = e.target.files[0].type.split("/")[1];

                            if (fileType !== "pdf") {
                                setOnErr(true);
                                setValError((err) => (
                                    {
                                        ...err,
                                        caption: "Error!",
                                        message: `Invalid file of type ${fileType}! Please upload a file of type pdf`,
                                        action: () => {
                                            setValError(null);
                                            setOnErr(false);
                                        }
                                    }
                                ))
                                return;
                            }
                            const uploadedFile = e.target.files[0];
                            const fileName = uploadedFile.name;
                            setPrevName(fileName);
                            setInputData((data) => (
                                { ...data, document: e.target.files[0] }
                            ))
                        }}
                    />
                    <button
                        onClick={() => fileButton.current.click()}
                        className="file-click"
                    >
                        <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 8 }} />
                        Upload file
                    </button>
                </div>

                {prevName && (
                    <div className={classNames("prev")}>
                        <FontAwesomeIcon icon={faFilePdf} color="#f00f00" />
                        {prevName}
                    </div>)
                }

                <button
                    className="form-button"
                    onClick={async (e) => {
                        e.preventDefault();
                        if (inputRequired()) {
                            setOnErr(true);
                            setValError((err) => (
                                {
                                    ...err,
                                    caption: "Error!",
                                    message: "Please provide all the required data",
                                    action: () => {
                                        setValError(null);
                                        setOnErr(false);
                                    }
                                }
                            ))
                            return;
                        } else {
                            setOnErr(false);
                            setValError((err) => ({ ...err, caption: null, message: null }));
                        }
                        setLoading(true);
                        const d = await createNewQuestion(inputData, token);
                        setLoading(false);
                        setValError({
                            caption: "Success",
                            message: d?.message,
                            action: () => {
                                setValError(null);
                                setOnErr(false);
                                window.location.reload();
                            }
                        })
                        setOnErr(true);
                    }}
                >
                    Upload Tutorial
                </button>
            </div>
        </div>
    );
}